import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';
import {Link} from 'react-router';
import Helmet from 'react-helmet';
import Spinner from '../../components/svg/spinner';
import css from './jury.scss';
import Image from '../../components/image/image';
import Dropdown from '../../components/dropdown/dropdown';
import { generateURL } from '../../routes/index';
import translate from '../../utils/translate';
import forEach from 'lodash/forEach';

import connect from '../../utils/connect';

import { fetchJury } from '../../actions/jury';

//import css from './editorial.scss';

class Jury extends Component {
	static propTypes = {
		browser: PropTypes.object.isRequired,
	};

	constructor(props) {
		super(props);

		this.mounted = true;
		this.scrollHandler = this.scrollHandler.bind(this);

		this.state = {
			searched: true,
			isSticky: false,
			stickAtPos: 0,
			stickyHeight: 0,
			headerHeight: 0,
		};

		this.query = '';
		this.offset = '';
		this.limit = '';
		this.order = '';
		this.orderBy = '';
		this.jury = [];
		this.already = [];
	}

	componentWillMount() {
		//console.log('editorial will mount');
		this.fetchJury = bindActionCreators(fetchJury, this.props.dispatch);

		this.fetchJury();

		if (this.props.browser) {
			this.props.browser.scroll.register(this.scrollHandler);
		}
	}

	componentDidMount() {
			this.updateDimensions();
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.browser.window.width !== nextProps.browser.window.width) {
			this.updateDimensions();
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.browser.window.width !== this.props.browser.window.width ||
			nextProps.jury.jury !== this.props.jury.jury ||
			nextState !== this.state
		);

		// update on init
		// if ((!this.props.items.length && nextProps.items.length)) {
		// 	return true;
		// }
	}

	componentWillUpdate() {
		this.state.searched = false;
	}

	componentWillUnmount() {
		this.mounted = false;
		if (this.props.browser) {
			this.props.browser.scroll.deregister(this.scrollHandler);
		}
	}

	render() {
		let spinnerClass = 'jury-list__spinner';

		if (this.state.searched) {
			spinnerClass += ' jury-list__spinner--active';
		}

		let extra = 0;

		let rowNum = 6;

		if (this.props.browser.window.width < 1200) {
			rowNum = 3;
		}

		if (this.props.browser.window.width >= 720 && this.props.jury.jury && this.props.jury.jury.length !== 36) {
			if (this.props.jury.jury.length < rowNum) {
				extra = rowNum - this.props.jury.jury.length;
			} else {
				extra = rowNum - (this.props.jury.jury.length % rowNum);
			}
		}

		let fillJury = [];

		for (var i = 0; i < extra; i++) {
			fillJury[i] = {
				name: 'fill',
				location: 'fill'
			};
		}

		let startNum = 1;
		let total = this.props.jury.jury.length;

		let offset = 0;

		if (this.props.jury.next) {
			let parameters = this.props.jury.next;
			parameters = parameters.split('/');
			parameters = parameters[parameters.length - 1];

			parameters = parameters.split('&');

			offset = parameters[0].split('=')[1];

			startNum = offset - this.props.jury.jury.length + 1;

			total = offset;

		};

		if (!this.props.jury.next && this.props.jury.prev) {
			let parameters = this.props.jury.prev;
			parameters = parameters.split('/');
			parameters = parameters[parameters.length - 1];

			parameters = parameters.split('&');

			offset = parameters[0].split('=')[1];

			startNum = parseInt(offset) + 37;

			total = parseInt(offset) + 36 + this.props.jury.jury.length;
		}

		let _this = this;

		let jury = this.props.jury.jury;
		let used = false;

		if (jury.length) {
			if (!this.already.length) {
				forEach(jury, function(single, i) {
					_this.jury.push(single);
				});
				this.already.push(jury[0].id);
			} else {
				forEach(this.already, function(already) {
					if (already == jury[0].id) {
						used = true;
					}
				});

				if (!used) {
					forEach(jury, function(single, i) {
						_this.jury.push(single);
					});

					this.already.push(jury[0].id);
				}
			}
		}

		const stickyStyle = {};
		const placeholderStyle = {};

		if (this.state.isSticky) {
			placeholderStyle.height = this.state.stickyHeight;

			stickyStyle.position = 'fixed';
			stickyStyle.top = this.state.headerHeight;
			stickyStyle.height = this.state.stickyHeight;
			stickyStyle.zIndex = 1;
		}

		return(
			this.props.jury.jury && (
				<article className='jobs-list span14'>
					<Helmet title='Jury members - The FWA' />
					<div style={placeholderStyle}></div>
					<div className='jobs-list__sticky' ref='stickyElement' style={stickyStyle}>
						<div className='jobs-list__top span14'>
							<h1 className='jobs-list__top__title'>Jury members</h1>
							<span className='jobs-list__top__number'> ({this.props.jury.totalJury})</span>
						</div>
						<input className='jobs-list__search span12 pixel-pattern hide-mobile' ref='stickyInput' onChange={(event) => this.jurySearch(event)} type='text' placeholder={translate('jury/jurySearch')} />
						<div className='span2 jury-list__right hide-mobile'>
							<span className='jobs-list__right__byline'>showing</span>
							<h2 className='jobs-list__right__title'>{startNum + ' — ' + total}</h2>
							<span className='jobs-list__right__number'>{this.props.jury.total + ' in total'}</span>
							<nav className='profile-list__right__nav'>
								{this.props.jury.prev && (
								<a href={this.props.jury.prev} onClick={(event) => this.juryNav(event)} className='profile-list__right__nav__prev pixel-pattern'><span className='profile-list__right__nav__arrow'></span></a>
								) || (
								<span className='profile-list__right__nav__prev pixel-pattern'><span className='profile-list__right__nav__arrow profile-list__right__nav__arrow--inactive'></span></span>
								)}
								{this.props.jury.next && (
								<a href={this.props.jury.next} onClick={(event) => this.juryNav(event)} className='profile-list__right__nav__next pixel-pattern'><span className='profile-list__right__nav__arrow'></span></a>
								) || (
								<span className='profile-list__right__nav__next pixel-pattern'><span className='profile-list__right__nav__arrow profile-list__right__nav__arrow--inactive'></span></span>
								)}
							</nav>
						</div>
					</div>
					<ul className='jobs-list__jobs span12 span14-mobile jury-list'>
						<li className={spinnerClass}>
							<Spinner className='jury-list__spinner__spinner' size='80px'></Spinner>
						</li>
						{this.props.jury.error && !this.props.jury.jury.length && (
							<li className='jury-list__jury jury-list__jury--error span12 span12-tablet span14-mobile'>
								<div className='jury-list__jury__content'>
									<h2 className='jury-list__jury__name'>{this.props.jury.error.error.title}</h2>
									<span className='jury-list__jury__location'>{this.props.jury.error.error.message}</span>
								</div>
							</li>
						) || this.props.browser.window.width < 720 && (
							this.jury.map((jury, i) => this.renderJury(jury, i))
						) || (
							this.props.jury.jury.map((jury, i) => this.renderJury(jury, i))
						)}
						{fillJury.map((extra, i) => this.renderExtra(extra, i))}
					</ul>
					{this.props.browser.window.width < 720 && this.props.jury.next && (
						<a href={this.props.jury.next} onClick={(event) => this.juryNav(event)} className='profile-list__right__nav__next pixel-pattern'><span className='profile-list__right__nav__arrow'></span></a>
					)}
				</article>
			) || (
				<Spinner className='case-single__spinner' size='80px'></Spinner>
			)
		);
	}

	renderExtra(extra, i) {
		return (
			<li key={'extra-' + i} className='jury-list__jury span2 span4-tablet span14-mobile'>
			</li>
		);
	}

	renderJury(jury, i) {
		let uid = 'jury-' + i;
		let ref = 'more-' + i;

		if (jury.name == 'Anders Nielsen West') {
			console.log(jury);
		}

		return (
			<li key={uid} className='jury-list__jury span2 span4-tablet span14-mobile' onClick={() => this.juryClick(ref)}>
				{jury.image && (
					<Image className='jury-list__jury__img' img={jury.image} span={{ desktop: 'span2', tablet: 'span4', mobile: 'span14' }} browser={this.props.browser} />
				)}
				<div className='jury-list__jury__content'>
					<h2 className='jury-list__jury__name'>{jury.name}</h2>
					<span className='jury-list__jury__location'>{jury.location}</span>
					<button ref={ref} onClick={(event) => {event.stopPropagation();}} className='jury-list__jury__more'>...</button>
					<Dropdown key='dropdown' attachTo={() => this.refs[ref]} pointTo='BOTTOM_LEFT' disablePattern={true} browser={this.props.browser} >
						<ol key='dropdown-ol'>
							{jury.website !== '' && (
							<li><a href={jury.website}>Personal/Company website</a></li>
							)}
							{jury.twitter !== '' && (
							<li><a href={jury.twitter}>Twitter</a></li>
							)}
							{jury.linkedin !== '' && (
							<li><a href={jury.linkedin}>LinkedIn</a></li>
							)}
							{!!jury.editorials.length && (
							<li className='jury-list__jury__more__seperator pixel-pattern--darker pixel-pattern--01'></li>
							)}
							{jury.editorials.map((editorial, i) => {
								return(
									<li key={'editorial' + i}><Link to={generateURL(editorial.types.slug, editorial.slug)}>{editorial.types.seriesName}</Link></li>
								);
							})}
						</ol>
					</Dropdown>
					<span className='jury-list__jury__partof'>{jury.partof}</span>
				</div>
			</li>
		);
	}

	juryClick(ref) {
		if (this.props.browser.window.width < 720) {
			console.log(ref);
			ReactDOM.findDOMNode(this.refs[ref]).click()
		}
	}

	juryNav(e) {
		e.preventDefault();
		let href = null;

		if (e.target.getAttribute('href')) {
			href = e.target.getAttribute('href');
		} else {
			href = e.target.parentNode.getAttribute('href');
		}

		let parameters = href;
		parameters = parameters.split('/');
		parameters = parameters[parameters.length - 1];

		parameters = parameters.split('&');

		let offset = parameters[0].split('=')[1];

		let limit = parameters[1].split('=')[1];

		let query = parameters[2].split('=')[1];

		this.setState({
			searched: true,
		});

		this.offset = offset;
		this.limit = limit;
		this.query = query;

		this.fetchJury(offset, limit, query);
	}

	jurySearch(e) {
		let string = e.target.value;

		let state = this.state.searched;
		let _this = this;

		clearTimeout(this.inputTimeout);

		this.query = string;

		this.inputTimeout = setTimeout(function() {
			_this.fetchJury(0, 36, string);
			_this.setState({
				searched: true,
			});
		}, 400);
	}

	updateDimensions() {
		const headerHeight = document.querySelector('.header-main').offsetHeight;
		const mainOffsetTop = this.refs.stickyElement ? this.refs.stickyElement.offsetTop : 0;
		const distanceToMenu = (mainOffsetTop - headerHeight) ? (mainOffsetTop - headerHeight) : 9999;

		const stickyHeight = (this.refs.stickyElement) ? this.refs.stickyElement.offsetHeight : 0;
		const inputHeight = (this.refs.stickyInput) ? this.refs.stickyInput.offsetHeight : 0;

		if (distanceToMenu === 9999) {
			setTimeout(() => {
				this.updateDimensions();
			}, 200);
		}

		this.mounted && this.setState({
			...this.state,
			stickAtPos: distanceToMenu,
			stickyHeight: stickyHeight + inputHeight,
			headerHeight: headerHeight,
		});
	}

	scrollHandler(e) {
		if (e.scrollY === this.prevSrollY) {
			return false; // noop
		} else {
			this.prevSrollY = e.scrollY;
		}

		const isMobile = (this.props.browser.window.width <= 719);
		const isSticky = (e.scrollY >= this.state.stickAtPos && !isMobile);

		if (this.state.stickyHeight <= 0 || this.state.stickAtPos <= 0) {
			return this.updateDimensions();
		}

		// stop setting state if not necessary
		if (this.state.isSticky === isSticky) {
			return false;  // noop
		}

		this.setState({
			...this.state,
			isSticky,
		});
	}
}

export default connect(Jury);



/** WEBPACK FOOTER **
 ** ./frontend/containers/jury/jury.js
 **/